// extracted by mini-css-extract-plugin
export default {"profileContainer":"AdminProfile_profileContainer__67iKr","loading":"AdminProfile_loading__1nFn0","forgotButton":"AdminProfile_forgotButton__l5P-4"};